var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Button from '../../Components/ComponentButton';
import Modal from '../../Components/ComponentModal';
import { appMessage, toggleModal } from '../../Actions';
import { shareValues, resetValuesForSharing } from './Actions';
import T from '../../Locale';
import Input from '../../Components/ComponentInput';
const validateEmail = (email) => {
    const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
};
class ComponentModalShare extends Component {
    constructor(props) {
        super(props);
        this.state = {
            email: '',
            error: false,
            isLoading: false
        };
        this.share = this.share.bind(this);
    }
    share() {
        return __awaiter(this, void 0, void 0, function* () {
            const { email } = this.state;
            const { dispatch, itemsForShare } = this.props;
            this.setState({ error: false, isLoading: true });
            if (!email.length) {
                this.setState({ error: T.translate('error.form.missingField'), isLoading: false });
                return;
            }
            if (!validateEmail(email)) {
                this.setState({ error: T.translate('error.form.email'), isLoading: false });
                return;
            }
            const response = yield dispatch(shareValues(email, itemsForShare));
            if (response === 200) {
                dispatch(resetValuesForSharing());
                dispatch(appMessage(T.translate('values.shareDone'), 'status'));
                dispatch(toggleModal());
                this.setState({ email: '' });
            }
            else if (response === 400) {
                this.setState({ error: T.translate('error.form.cprLength') });
            }
            else if (response === 406) {
                this.setState({ error: T.translate('values.shareErrorSelf') });
            }
            else {
                this.setState({ error: T.translate('error.unknown') });
            }
            this.setState({ isLoading: false });
        });
    }
    render() {
        const { error, email, isLoading } = this.state;
        return (_jsxs(Modal, Object.assign({ modalKey: "share-value", title: T.translate('values.shareHeadline'), content: T.translate('values.share') }, { children: [_jsx("h5", { children: T.translate('misc.email') }), _jsx("span", Object.assign({ className: "form-error is-visible" }, { children: error })), _jsx(Input, { type: "email", error: error !== false, onChange: (value) => this.setState({ email: value }), value: email, required: true }), _jsx("br", {}), _jsx(Button, Object.assign({ isLoading: isLoading, onClick: this.share }, { children: T.translate('misc.confirm') }))] })));
    }
}
ComponentModalShare.propTypes = {
    itemsForShare: PropTypes.array,
    dispatch: PropTypes.func.isRequired
};
ComponentModalShare.defaultProps = { itemsForShare: [] };
const mapStateToProps = (state) => ({
    items: state.values.items,
    itemsForShare: state.values.itemsForShare
});
export default connect(mapStateToProps)(ComponentModalShare);
